import About from "./components/About/About";
import Header from "./components/Header";
import Hero from "./components/Hero/Hero";
import WorkExperience from "./components/WorkExperience/WorkExperience";
import SkillsSection from "./components/SkillsSection/SkillsSection";
import Projects from "./components/Projects/Projects";
import ContactMe from "./components/ContactMe/ContactMe";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <div className="bg-[rgb(36,36,36)] text-white h-screen snap-y snap-mandatory overflow-x-hidden overflow-y-scroll z-0 sm:scrollbar-thin sm:scrollbar-thumb-[#F7AB0A]/80 sm:scrollbar-transparent sm:scrollbar-thumb-rounded-full sm:scrollbar-track-rounded-full">
        {/* Header */}
        <Header />

        {/* Hero */}
        <section id="hero" className="snap-start">
          <Hero />
        </section>

        {/* About */}
        <section id="about" className="snap-center snap-mandatory  snap-always">
          <About />
        </section>

        {/* Work Experience */}
        <section
          id="experience"
          className="snap-start snap-mandatory snap-always"
        >
          <WorkExperience />
        </section>

        {/* Skills new section */}
        <section id="skills" className="snap-start snap-mandatory  snap-always">
          <SkillsSection />
        </section>

        {/* Projects */}
        <section
          id="projects"
          className="snap-start snap-mandatory  snap-always"
        >
          <Projects />
        </section>

        {/* Contact Me */}
        <section
          id="contact"
          className="snap-start snap-mandatory  snap-always"
        >
          <ContactMe />
        </section>
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
